exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mu-select-input,\n.mu-select-icon {\n  color: black !important;\n}\n@media only screen and (max-width: 1170px) {\n.select-regimen {\n    color: black !important;\n}\n}\n.bx {\n  color: #ffffff;\n}\n.statusConcept {\n  width: 50px;\n  background: #909497;\n}\n.statusConcept :hover {\n  background: #797D7F;\n}\n.select-regimen {\n  color: black !important;\n}\n@media only screen and (max-width: 1170px) {\n.select-regimen {\n    color: black !important;\n}\n}", ""]);

// exports
